import { useEffect, useRef, useState } from 'react';

import { setAppVersion } from '@/monitoring/sentry.util.ts';

const VERSION_CHECK_INTERVAL_MS = 60 * 1000; // 1 minute

export interface UseVersionCheckResult {
  isNewVersionAvailable: boolean;
}

export const useVersionCheck = (): UseVersionCheckResult => {
  const [isNewVersionAvailable, setIsNewVersionAvailable] = useState(false);
  const currentVersionRef = useRef<string | null>(null);

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const response = await fetch('/version.json?t=' + Date.now());
        if (!response.ok) {
          return;
        }
        const data = (await response.json()) as { version: string };
        const serverVersion = data.version;

        if (currentVersionRef.current === null) {
          currentVersionRef.current = serverVersion;
          setAppVersion(serverVersion);
        } else if (currentVersionRef.current !== serverVersion) {
          setIsNewVersionAvailable(true);
        }
      } catch (error) {
        console.error('Failed to check version', error);
      }
    };

    // Initial check
    void checkVersion();

    const intervalId = setInterval(checkVersion, VERSION_CHECK_INTERVAL_MS);

    return () => clearInterval(intervalId);
  }, []);

  return { isNewVersionAvailable };
};
